<template>
  <el-dialog
    @open="onOpen"
    :visible.sync="visibility"
    :before-close="abortarSelecao"
    :close-on-click-modal="false"
    width="70%"
    :modal-append-to-body="false"
  >
    <span slot="title">
      Selecionar Imagem da Capa <i class="el-icon-picture" />
    </span>

    <el-row>
      <div style="full-height">
        <div class="images">
          <div class="image-wrapper" v-for="imagem in listaImagens" :key="imagem.id">
            <img @dblclick="handleSelecaoImagem(imagem)" :src="imagem.path" alt="" class="image">
          </div>
        </div>
      </div>
    </el-row>

    <span slot="footer">
      <el-row type="flex" justify="end">
        <el-button @click="abortarSelecao" size="mini" type="danger" round class="btn-box-shadow">Fechar <i class="el-icon-close" /></el-button>
      </el-row>
    </span>
  </el-dialog>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  .images {
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    padding: 5px;
    .image-wrapper {
      display: inline-block;
      width: calc(33% - 20px);
      height: 250px;
      margin: 5px 5px 0 5px;
      background-color: rgba(209, 209, 209, 0.3);
      border: 3px #000 solid;
      .image {
        height: 210px;
        max-width: 100%;
        cursor: pointer;
        display: inline-block;
      }
    }
  }
</style>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean,
    imovel: Object
  },
  data() {
    return {
      listaImagens: [],
    }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("siteStore", [
      "recuperarImagensImovel"
    ]),

    reset() {
      this.listaImagens = [];
    },

    onOpen() {
      this.reset();

      this.showLoading();
      this.recuperarImagensImovel(this.imovel).then((imagens) => {
        if(imagens.length == 0) {
          this.exibirAlerta('O imóvel selecionado não possui imagens');
          this.abortarSelecao();
        }
        this.hideLoading();
        this.listaImagens = imagens;
      }).catch(() => {
        this.hideLoading();
      });
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
    },

    abortarSelecao() {
      this.$emit("close");
    },

    concluir(imagemSelecionada) {
      this.$emit("close", imagemSelecionada);
    },

    handleSelecaoImagem(imagem) {
      this.concluir(imagem);
    }
  }
}
</script>